var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"avatar"},[(_vm.isAi)?_c('AvatarSprite',{attrs:{"player":_vm.player,"moveAction":_vm.moveAction}}):_c('div',{staticClass:"image"},[_c('AvatarImg',{attrs:{"player":_vm.player}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }